import React from "react";

import FocusLock from "react-focus-lock";

import { useTranslation } from "react-i18next";

import closeIcon from "./img/close_icon.svg";
import exploreIcon from "./img/explore.svg";

import "./index.css";

import { Button } from "@learningblocks/shared-components/lib/Button";

export default function LinkConfirmationOverlay(props) {
  const { t } = useTranslation("translation");

  return (
    <FocusLock disabled={props.debug}>
      <div className="link-confirmation-overlay">
        <div
          className="link-confirmation-dialogue"
          style={{
            width:
              props.bp === "sm" || props.bp === "xs"
                ? "calc(100% - 70px)"
                : "50%",
          }}
        >
          <div
            className="close-link-confirmation"
            style={{ position: "relative" }}
          >
            <div
              className="close-link-confirmation-btn"
              tabIndex={0}
              role="button"
              onClick={props.close}
              onKeyUp={(e) => {
                const keycode = e.keyCode ? e.keyCode : e.which;
                if (keycode === 13) {
                  props.close;
                }
              }}
            >
              {t("close.string")}
              <img
                className="closeImg"
                alt=""
                role="presentation"
                src={closeIcon}
              />
            </div>
          </div>
          <div className="explore-image-container">
            <img
              className="explore-image"
              alt=""
              role="presentation"
              src={exploreIcon}
            />
          </div>
          <p className="external-link-warning">
            You are about to leave LabXchange
          </p>
          <p className="external-link-url">
            If you click the continue button below, you will be taken to: <br />
            [{props.url}]
          </p>
          <div
            style={{
              position: "relative",
              height: props.bp === "sm" || props.bp === "xs" ? "50px" : null,
            }}
          >
            <Button
              type="secondary"
              className="external-link-return-btn"
              style={{
                width:
                  props.bp === "sm" || props.bp === "xs"
                    ? "calc(100% - 3px)"
                    : "calc(50% - 3px)",
              }}
              onClick={props.close}
              onKeyUp={(e) => {
                const keycode = e.keyCode ? e.keyCode : e.which;
                if (keycode === 13) {
                  props.close;
                }
              }}
            >
              {t("return.string")}
            </Button>
            <Button
              type="primary"
              className="external-link-continue-btn"
              style={{
                right: props.bp === "sm" || props.bp === "xs" ? "3px" : "0px",
                top: props.bp === "sm" || props.bp === "xs" ? "12px" : "-42px",
                width:
                  props.bp === "sm" || props.bp === "xs"
                    ? "calc(100% - 3px)"
                    : "calc(50% - 3px)",
              }}
              onClick={() => {
                window.open(props.url);
                props.close();
              }}
              onKeyUp={(e) => {
                const keycode = e.keyCode ? e.keyCode : e.which;
                if (keycode === 13) {
                  window.open(props.url);
                  props.close();
                }
              }}
            >
              {t("continueToSite.string")}
            </Button>
          </div>
        </div>
      </div>
    </FocusLock>
  );
}
